<template>
  <div id="userAccount-page">
    <div class="accountInner">
      <div class="listTop">
        <div class="listTopTextBox">
          <div class="textBoxLeft">
            <div class="icon"></div>
            <span>我的累计</span>
          </div>
          <div
            class="textBoxRight"
            v-if="userInfo.unReceivePrice>0"
          >
            <van-button
              @click="getPanelTranClick"
              round
              size="mini"
              color="#F46B6B"
            >马上领取</van-button>
          </div>
        </div>
        <div class="bottomLine"></div>
      </div>
      <div class="accountMid">
        <van-row>
          <van-col span="12">
            <div class="colTitle">酬金总额</div>
            <div class="btnCardBox">
              <div class="btnCard">
                {{`${userInfo.totalPrice?userInfo.totalPrice:0}元`}}
              </div>
            </div>
          </van-col>
          <van-col span="12">
            <div class="colTitle">已领取</div>
            <div class="btnCardBox">
              <div class="btnCard">
                {{`${userInfo.receivePrice?userInfo.receivePrice:0}元`}}
              </div>
            </div>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="12">
            <div class="colTitle red">可领取</div>
            <div class="btnCardBox">
              <div class="btnCard red">
                {{`${userInfo.unReceivePrice?userInfo.unReceivePrice:0}元`}}
              </div>
            </div>
          </van-col>
          <van-col span="12">
            <div class="colTitle gray">未到账</div>
            <div class="btnCardBox">
              <div class="btnCard gray">
                {{`${userInfo.lockPrice?userInfo.lockPrice:0}元`}}
              </div>
            </div>
          </van-col>
        </van-row>
      </div>
      <div class="accountMain">
        <div class="mainTop">
          <div class="mainTopL">
            <van-tabs
              @click="clickFn"
              v-model="active"
              color="#33C2AC"
              type="card"
            >
              <van-tab
                v-for="(tab,index) in tabList"
                :key="index"
              >
                <template #title>
                  <van-icon
                    :name="tab.iconClass"
                    :color="active==index?'#ffffff':'#5c5b5b'"
                  />
                  <span class="titleText">{{tab.title}}</span>
                </template>
              </van-tab>
            </van-tabs>
          </div>
          <!-- <div class="mainTopR">
            <div class="totalText">累计</div>
            <div class="totalNum">{{`${userInfo.totalPrice}元`}}</div>
          </div> -->
        </div>
        <div class="listBox">
          <div class="listTitle">
            <van-row v-show="active===0">
              <van-col span="9">项目</van-col>
              <van-col span="3">酬金</van-col>
              <van-col span="6">完成时间</van-col>
              <van-col span="6">领取日期</van-col>
            </van-row>
            <van-row v-show="active===1">
              <van-col span="6">昵称</van-col>
              <van-col span="6">他的酬金</van-col>
              <van-col span="6">我的佣金</van-col>
              <van-col span="6">领取日期</van-col>
            </van-row>
          </div>
          <div class="listMain">
            <!-- 自己项目列表 -->
            <div
              class="selfBox"
              v-if="active===0"
            >
              <div class="selfList">
                <van-list
                  v-model="userloading"
                  :finished="userFinished"
                  :finished-text="userList.length?'没有更多了':''"
                  @load="userOnLoad"
                >
                  <div
                    class="listItem"
                    v-for="(item,index) in userList"
                    :key="index"
                    :title="item"
                  >
                    <van-row>
                      <van-col span="9">{{item.title}}</van-col>
                      <van-col span="3">{{item.actualPrice}}</van-col>
                      <van-col span="6">{{item.finishTime?item.finishTime.slice(0,10):''}}</van-col>
                      <van-col span="6">{{item.isRecieve?(item.recievePriceTime?item.recievePriceTime.slice(0,10):''):'未领取'}}</van-col>
                    </van-row>
                  </div>
                </van-list>
                <van-empty
                  description="暂无数据"
                  v-show="userList.length<=0&&userFinished"
                />
              </div>
            </div>
            <!-- 分享列表 -->
            <!-- <div
              class="shareBox"
              v-if="active===1"
            >
              <div class="shareList">
                <van-list
                  v-model="friendloading"
                  :finished="friendFinished"
                  :finished-text="friendList.length?'没有更多了':''"
                  @load="friendOnLoad"
                >
                  <div
                    class="listItem"
                    v-for="(item,index) in friendList"
                    :key="index"
                    :title="item"
                  >
                    <van-row>
                      <van-col span="6">{{item.toPanelName}}</van-col>
                      <van-col span="6">{{item.toPanelPrice}}</van-col>
                      <van-col span="6">{{item.actualPrice}}</van-col>
                      <van-col span="6">{{item.isRecieve?(item.recievePriceTime?item.recievePriceTime.slice(0,10):''):'未领取'}}</van-col>
                    </van-row>
                  </div>
                </van-list>
                <van-empty
                  description="暂无数据"
                  v-show="friendList.length<=0&&friendFinished"
                />
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <van-dialog v-model="show" title="提交手机号码" show-cancel-button :beforeClose="beforeClose" confirmButtonText="保存">
      <van-form :show-error-message="false" class="dialogForm" ref="dialogForm">
        <van-field
          v-model="mobilePhone"
          name="手机号"
          label="手机号"
          placeholder="请填写手机号"
          :rules="[{ required: true, message: '请填写手机号' }]"
        />
        <div class="codeBox">
          <van-field
            v-model="smsCode"
            name="验证码"
            label="验证码"
            placeholder="请填写验证码"
            :rules="[{ required: true, message: '请填写验证码' }]"
          />
          <div :class="['getCode',isSending?'disable':'']" @click="getCode">{{isSending?`${countDown}S`:'获取验证码'}}</div>
        </div>
        <!-- <div style="margin: 16px;">
          <van-button round block type="info" >
            提交
          </van-button>
        </div> -->
      </van-form>
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {
        unReceivePrice: 0,
        totalPrice: 0,
        receivePrice: 0
      },
      tabList: [
        {
          title: '我的项目',
          iconClass: 'orders-o'
        },
        // {
        //   title: '我的好友',
        //   iconClass: 'friends-o'
        // }
      ],
      active: 0,
      userList: [],
      userloading: false,
      userFinished: false,
      userPageIndex: 1,
      friendList: [],
      friendloading: false,
      friendFinished: false,
      friendPageIndex: 1,
      show:false,
      mobilePhone:'',
      smsCode:'',
      countDown:60,
      isSending:false
    }
  },
  components: {},
  async created() {
    if (navigator.userAgent.indexOf('iPhone') !== -1) {
      // 兼容ios 生成签名的当前页面地址取值 ios url地址为入口地址
      if (window.wechaturl === undefined) {
        window.wechaturl = window.location + ''
      }
    }
    this.getUserInfo()
  },
  methods: {
    clickFn() {
      this.onRefresh()
      console.log(this.userList)
    },
    // 上拉刷新个人呢列表
    userOnLoad() {
      this.getUserQuesList()
    },
    // 上拉刷新好友列表
    // friendOnLoad() {
    //   this.getFriendQuesList()
    // },
    // 获取个人项目列表
    async getUserQuesList() {
      let params = {
        pageSize: 10,
        pageIndex: this.userPageIndex
      }
      let data = await $api.getQuestionnaireRecords(params)
      if (data) {
        if (data.rows.length) {
          this.userPageIndex++
          this.userList.push(...data.rows)
        } else {
          this.userFinished = true
        }
      } else {
        this.userFinished = true
      }
      this.userloading = false
    },
    // 获取分享好友列表
    async getFriendQuesList() {
      let params = {
        pageSize: 10,
        pageIndex: this.friendPageIndex
      }
      let data = await $api.getShareRecords(params)
      if (data) {
        if (data.rows.length) {
          this.friendPageIndex++
          this.friendList.push(...data.rows)
        } else {
          this.friendFinished = true
        }
      } else {
        this.friendFinished = true
      }
      this.friendloading = false
    },
    // 获取个人账号信息
    getUserInfo() {
      $api.getPanel().then(res => {
        this.userInfo = res
      })
    },
    // 重新更新列表
    onRefresh() {
      this.userPageIndex = 1
      this.friendPageIndex = 1
      this.userFinished = false
      this.friendFinished = false
      this.userloading = true
      this.friendloading = true
      this.userList = []
      this.friendList = []
      this.userOnLoad()
      // this.friendOnLoad()
    },
    // 提现
    getPanelTran() {
      let openId = this.userInfo ? this.userInfo.openID : ''
      if (openId) {
        $api.getPanelTran(openId).then(res => {
          if (res) {
            this.$toast.success('提现成功')
            this.getUserInfo()
            this.onRefresh()
          } else {
            // Toast('提现失败')
            this.$toast.fail('提现失败')
          }
        })
      }
    },
    async getPanelTranClick(){
      if(this.userInfo.mobilePhone){
        this.getPanelTran()
      }else{
        this.$toast('您还没绑定手机，请先绑定手机再领取')
        this.show = true
      }
    },
    async getCode(){
      if(this.mobilePhone){
        if(!this.isSending){
          if(this.testPhone(this.mobilePhone)){
            this.isSending = true
            let timer = setInterval(()=>{
              this.countDown--
              if(this.countDown<1){
                clearInterval(timer);
                this.countDown = 60
                this.isSending = false
              }
            },1000)
            let params = {
                mobilePhone:this.mobilePhone
            }
            let data = await $api.sendSMS(params)
            if(data){
              this.$toast('已经发送验证码，请查收')
            }
          }else{
            this.$toast('请输入正确的11位手机号码')
          }
        }
      }else{
        this.$toast('请填写手机号码')
      }
    },
    beforeClose(action,done){
      if(action === 'confirm'){
        this.setBindPhone(done)
      }else{
        done()
        this.resetVal()
      }
    },
    async setBindPhone(done){
      done(false)
      if(!this.testPhone(this.mobilePhone)){
        this.$toast('请输入正确的11位手机号码')
        return 
      }
      if(!this.smsCode){
        this.$toast('请输入短信验证码')
        return 
      }
      let params = {
        mobilePhone: this.mobilePhone,
        smsCode: this.smsCode
      }
      let data = await $api.bindPhone(params)
      if(data){
        this.$toast('保存成功')
        this.getUserInfo()
        this.resetVal()
        this.show = false
      }
    },
    testPhone(val){
      let reg = /^1[3456789]\d{9}$/
      return reg.test(val)
    },
    resetVal(){
      this.mobilePhone=''
      this.smsCode=''
      this.countDown = 60
      this.isSending = false
      this.$refs.dialogForm.resetValidation()
    }
  }
}
</script>
<style lang='less'>
#userAccount-page {
  //40边距
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px 20px 0;
  overflow: auto;
  background: url('../../assets/images/bg.png');
  .accountInner {
    width: 100%;
    height: 100%;
    .listTop {
      //38
      .listTopTextBox {
        // font-size: 18px;
        color: #fff;
        height: 32px;
        padding: 0 25px;
        // font-style: italic;
        // letter-spacing: 3px;
        background: @colorDefault;
        margin-bottom: 4px;
        .textBoxLeft {
          float: left;
          display: flex;
          height: 32px;
          align-items: center;
          .icon {
            width: 21px;
            height: 21px;
            background: url('../../assets/images/rmb.png');
            background-size: 100% 100%;
          }
          span {
            font-size: 18px;
            margin-left: 5px;
          }
        }
        .textBoxRight {
          float: right;
          display: flex;
          height: 32px;
          align-items: center;
          font-size: 10px;
          .van-button--mini {
            padding: 0 12px;
          }
        }
      }
      .bottomLine {
        height: 2px;
        background-color: @colorDefault;
      }
      // margin-bottom: 10px;
    }
    .accountMid {
      // (32+25)*2+15 = 129
      .colTitle {
        font-size: 12px;
        color: #00b397;
        height: 32px;
        line-height: 32px;
        text-align: center;
        font-weight: 400;
        &.red {
          color: #f46b6b;
        }
        &.gray {
          color: #ccc;
        }
      }
      margin-bottom: 15px;
    }
    .btnCardBox {
      width: 100%;
      display: flex;
      justify-content: center;
      .btnCard {
        width: 81px;
        height: 25px;
        border-radius: 25px;
        background-color: #fff;
        line-height: 25px;
        text-align: center;
        color: #00b397;
        font-size: 10.5px;
        &.red {
          color: #fff;
          background-color: #f46b6b;
        }
        &.gray {
          color: #fff;
          background-color: #ccc;
        }
      }
    }
    .accountMain {
      height: calc(100vh - 40px - 38px - 129px - 40px);
      background: #fff;
      border-radius: 3px;
      padding: 0 23px;
      .mainTop {
        // 32px
        height: 32px;
        .mainTopL {
          float: left;
          width: 157px;
          .van-tabs__wrap {
            height: 32px;
            .van-tabs__nav--card {
              margin: 0;
              height: 32px;
              border: none;
              .van-tab {
                padding: 0;
                border: none;
                border-bottom-left-radius: 16px;
                border-bottom-right-radius: 16px;
                .van-tab__text {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  .project {
                    width: 14px;
                    height: 14px;
                    background: url('../../assets/images/projectGray.png');
                    background-size: 100% 100%;
                    padding-right: 2px;
                  }
                  .friend {
                    width: 14px;
                    height: 14px;
                    background: url('../../assets/images/friendGray.png');
                    background-size: 100% 100%;
                    padding-right: 2px;
                  }
                  .titleText {
                    color: #5c5b5b;
                    margin-left: 2px;
                  }
                }
                &.van-tab--active {
                  .van-tab__text {
                    .project {
                      background: url('../../assets/images/project.png');
                      background-size: 100% 100%;
                    }
                    .friend {
                      background: url('../../assets/images/friend.png');
                      background-size: 100% 100%;
                    }
                    .titleText {
                      color: #fff;
                    }
                  }
                }

                // &:last-child {
                //   &.van-tab--active {
                //     background-color: #f46b6b !important;
                //   }
                // }
                .titleText {
                  font-size: 12px;
                }
              }
            }
          }
        }
        .mainTopR {
          float: right;
          height: 32px;
          // display: flex;
          align-items: center;
          color: #00b397;
          justify-content: center;
          .totalText {
            margin-top: 6.5px;
            font-size: 10px;
            text-align: center;
            line-height: 1;
            margin-bottom: 3.5px;
          }
          .totalNum {
            font-size: 13px;
            text-align: center;
            line-height: 1;
          }
        }
      }
      .listBox {
        // 26px
        .listTitle {
          height: 26px;
          font-size: 11px;
          border-bottom: 1px solid #5c5b5b;
          .van-col {
            height: 26px;
            text-align: center;
            line-height: 26px;
            color: #474747;
            &:first-child {
              text-align: left;
            }
          }
        }
        .listMain {
          height: calc(100vh - 40px - 38px - 129px - 32px - 26px - 10px - 40px);
          overflow: auto;
          .listItem {
            // height: 25px;
            padding: 5px 0;
            .van-col {
              line-height: 15px;
              font-size: 9px;
              text-align: center;
              color: #5c5b5b;
              &:first-child {
                text-align: left;
              }
            }
          }
        }
      }
    }
  }
  .clearFix:after {
    content: '';
    display: block;
    clear: both;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }
  .dialogForm{
    margin-bottom: 20px;
  }
  .codeBox{
    display: flex;
    align-items: center;
    
    .van-cell{
      width: 65%;
    }
    .getCode{
      margin-left: 1%;
      width: 30%;
      height: 30px;
      background-color: #00b397;
      border-radius: 3px;
      color: #fff;
      text-align: center;
      line-height: 30px;

    }
    .disable.getCode{
      background-color: #ccc;
      color: #fff;
    }
  }
  .van-field__label{
    width: 1.4rem;
  }
  .van-dialog__confirm, .van-dialog__confirm:active {
    color: #00b397;
 }
}
</style>
